<template>
  <v-form v-if="consumerUnit && consumerUnit.id">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="teal" class="white--text" right>
          <div class="align--right">
            <div>
              <v-icon left dark>house_siding</v-icon>
              {{
                consumerUnit.utility_company === "CELPE"
                  ? consumerUnit.installation_number
                  : consumerUnit.id
              }}<br />
            </div>
            <span v-html="consumerUnit.address.address"></span>
          </div>
        </v-btn>
        <v-chip
          v-if="consumerUnits.length > 1"
          small
          dark
          color="teal"
          class="white--text"
          >{{ consumerUnits.length }}</v-chip
        >
      </template>
      <v-list two-line>
        <v-list-tile
          v-for="(item, index) in consumerUnits"
          :key="index"
          @click="selectConsumerUnit(item)"
        >
          <v-list-tile-content>
            <v-list-tile-title v-html="item.id"></v-list-tile-title>
            <v-list-tile-sub-title
              v-if="item.address"
              v-html="item.address.address"
            ></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-form>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      autoUpdate: true,
      data: {},
      ucs: [],
      isUpdating: false,
    };
  },

  computed: {
    ...mapState("cs", ["consumerUnit"]),
    ...mapGetters("cs", ["consumerUnits"]),
  },

  created() {
    this.ucs = this.consumerUnits;
  },

  watch: {
    ucs(val) {
      this.setConsumerUnitsOpened(val);
    },
  },

  methods: {
    ...mapMutations("cs", [
      "setConsumerUnitsOpened",
      "setConsumerUnit",
      "setActiveBilling",
    ]),

    selectConsumerUnit(item) {
      this.setConsumerUnit(item);
      this.setActiveBilling(0);
    },

    remove(item) {
      const index = this.ucs.indexOf(item.name);
      if (index >= 0) {
        this.ucs.splice(index, 1);
        this.setConsumerUnitsOpened(this.ucs);
      }
    },
  },
};
</script>
